var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open
    ? _c(
        "portal",
        { attrs: { to: "app-modal" } },
        [
          _c("transition", { attrs: { name: "modal" } }, [
            _c(
              "div",
              {
                staticClass: "modal-mask",
                class: _vm.theme,
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.close($event)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-wrapper" },
                  [
                    !_vm.hideClose
                      ? _c(
                          "x-button",
                          {
                            staticClass: "modal-close-button md-icon-button",
                            attrs: { disabled: _vm.loading },
                            on: { click: _vm.close }
                          },
                          [_c("icn-close")],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "confirm"
                      ? _c("div", { staticClass: "modal-confirm" }, [
                          _c("div", { staticClass: "modal-confirm-text" }, [
                            _c("h1", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.title) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.text) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "modal-confirm-buttons" },
                            [
                              _c(
                                "x-button",
                                {
                                  staticClass: "md-raised",
                                  attrs: { disabled: _vm.loading },
                                  on: { click: _vm.close }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("buttons.cancel")) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "x-button",
                                {
                                  staticClass: "md-raised md-primary",
                                  attrs: {
                                    disabled: _vm.loading,
                                    loading: _vm.loading
                                  },
                                  on: { click: _vm.submit }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("buttons.validate")) +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      : _c(
                          "div",
                          {
                            class: [
                              "custom-modal-container",
                              { "modal-thin-size": _vm.widthSize === "thin" }
                            ]
                          },
                          [
                            _vm.$slots.sidebar
                              ? _c(
                                  "div",
                                  { staticClass: "modal-sidebar" },
                                  [_vm._t("sidebar")],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class: [
                                  "modal-container",
                                  { "has-sidebar": _vm.$slots.sidebar }
                                ]
                              },
                              [
                                _vm.$slots.header
                                  ? _c(
                                      "header",
                                      [
                                        _c("div", {
                                          staticClass: "modal-border-top"
                                        }),
                                        _vm._v(" "),
                                        _vm._t("header")
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "modal-body" },
                                  [_vm._t("body")],
                                  2
                                )
                              ]
                            )
                          ]
                        )
                  ],
                  1
                )
              ]
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }